module.exports = __webpack_public_path__ + "img/webrtc.d9e96ae9.svg";